import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-icon-line-chart-up-02',
  standalone: true,
  templateUrl: './rt-icon-line-chart-up-02.component.html',
  styleUrls: ['./rt-icon-line-chart-up-02.component.scss']
})
export class RtIconLineChartUp02Component {
  @Input() width: number | string = 15;
  @Input() height: number | string = 15;
}
